import { render, staticRenderFns } from "./maintainance.vue?vue&type=template&id=c82a2da6&"
import script from "./maintainance.vue?vue&type=script&lang=js&"
export * from "./maintainance.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports